export const MATCH_WITH_PAC_CLASSIC_USER_START = "MATCH_WITH_PAC_CLASSIC_USER_START"
export const MATCH_WITH_PAC_CLASSIC_USER_SUCCESS = "MATCH_WITH_PAC_CLASSIC_USER_SUCCESS"
export const MATCH_WITH_PAC_CLASSIC_USER_FAILURE = "MATCH_WITH_PAC_CLASSIC_USER_FAILURE"
export const SET_SUBMISSION_STATUS = "SET_SUBMISSION_STATUS"
